<template>
	<v-btn small icon class="mr-1" @click="navBack">
		<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-arrow-left</v-icon>
	</v-btn>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'bar-nav-back',
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize']),
	},
	methods: {
		navBack() {
			this.$emit('navBack');
		},
	},
}
</script>
